import { render, staticRenderFns } from "./DateFromChannels.vue?vue&type=template&id=21e7264e&scoped=true&"
import script from "./DateFromChannels.vue?vue&type=script&lang=js&"
export * from "./DateFromChannels.vue?vue&type=script&lang=js&"
import style0 from "./DateFromChannels.vue?vue&type=style&index=0&id=21e7264e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7264e",
  null
  
)

export default component.exports